// import React from "react";

// interface Column {
//   key: string;
//   title: string;
//   render?: (value: any, row: any) => React.ReactNode;
// }

// interface CustomTableProps {
//   title?: string;
//   className?: string;
//   columns: Column[];
//   data: any[];
// }

// const CustomMainTable: React.FC<CustomTableProps> = ({
//   title,
//   columns,
//   data,
//   className = "",
// }) => {
//   return (
//     <div className={`w-full rounded-3xl p-6 ${className}`}>
//       {/* Header */}
//       {title && (
//         <div className="mb-4">
//           <h2 className="text-lg font-medium  text-[#212121]">{title}</h2>
//         </div>
//       )}

//       {/* Table */}
//       <div className="max-h-[400px] overflow-y-scroll hide-scrollbar">
//         <div className="overflow-x-auto ">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="border-b border-[#D2D2D2]">
//                 {columns.map((column) => (
//                   <th
//                     key={column.key}
//                     className="pb-4 text-left text-xs font-semibold uppercase tracking-wider text-[#212121]"
//                   >
//                     {column.title}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {data.map((row, rowIndex) => (
//                 <tr
//                   key={rowIndex}
//                   className="border-b border-[#D2D2D2] transition hover:bg-[#FFFFFD]"
//                 >
//                   {columns.map((column) => (
//                     <td
//                       key={column.key}
//                       className="py-5 text-sm text-[#212121]/70"
//                     >
//                       {column.render
//                         ? column.render(row[column.key], row)
//                         : row[column.key]}
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomMainTable;

import React from "react";

interface Column {
  key: string;
  title: string;
  render?: (value: any, row: any) => React.ReactNode;
}

interface CustomTableProps {
  title?: string;
  className?: string;
  columns: Column[];
  data: any[];
}

const CustomMainTable: React.FC<CustomTableProps> = ({
  title,
  columns,
  data,
  className = "",
}) => {
  return (
    <div className={`h-full rounded-[28px] p-6 ${className}`}>
      {/* Header */}
      {title && (
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-[#111827]">{title}</h2>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="overflow-hidden rounded-2xl border border-[#F1F5F9]">
        <div className="max-h-[420px] overflow-y-auto">
          <table className="w-full border-collapse">
            {/* Header */}
            <thead className="sticky top-0 z-10 bg-[#F8FAFC]">
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.key}
                    className="px-6 py-5 text-left text-xs font-bold uppercase whitespace-nowrap tracking-wider text-[#64748B]"
                  >
                    {column.title}
                  </th>
                ))}
              </tr>
            </thead>

            {/* Body */}
            <tbody className="bg-white">
              {data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className="border-t border-[#F1F5F9] transition-all duration-200 hover:bg-[#FAFAFA]"
                >
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      className="px-6 py-5 text-sm font-medium text-[#374151]"
                    >
                      {column.render
                        ? column.render(row[column.key], row)
                        : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}

              {/* Empty State */}
              {data.length === 0 && (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="py-20 text-center text-sm text-[#94A3B8]"
                  >
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomMainTable;
